var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C9.27729 24.0093 2.66663 20.4187 2.66663 16C2.66663 11.5813 9.31196 7.97735 16 8.00001C22.688 8.02268 29.3333 11.5813 29.3333 16C29.3333 20.4187 22.7226 23.9907 16 24ZM16 21.3333C17.4144 21.3333 18.771 20.7714 19.7712 19.7713C20.7714 18.7711 21.3333 17.4145 21.3333 16C21.3333 14.5855 20.7714 13.229 19.7712 12.2288C18.771 11.2286 17.4144 10.6667 16 10.6667C14.5855 10.6667 13.2289 11.2286 12.2287 12.2288C11.2285 13.229 10.6666 14.5855 10.6666 16C10.6666 17.4145 11.2285 18.7711 12.2287 19.7713C13.2289 20.7714 14.5855 21.3333 16 21.3333ZM16 18.6667C15.2927 18.6667 14.6144 18.3857 14.1143 17.8856C13.6142 17.3855 13.3333 16.7073 13.3333 16C13.3333 15.2928 13.6142 14.6145 14.1143 14.1144C14.6144 13.6143 15.2927 13.3333 16 13.3333C16.7072 13.3333 17.3855 13.6143 17.8856 14.1144C18.3857 14.6145 18.6666 15.2928 18.6666 16C18.6666 16.7073 18.3857 17.3855 17.8856 17.8856C17.3855 18.3857 16.7072 18.6667 16 18.6667Z",
    fill: "url(#paint0_linear_1257_3956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1257_3956",
    x1: 3.04758,
    y1: 8.83325,
    x2: 8.8717,
    y2: 29.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cac7c1685a126a0ae67bbd7572ec766d.svg";
export { ForwardRef as ReactComponent };